import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLearningBundles,
  createLearningBundle,
  updateLearningBundle,
  deleteLearningBundle,
  updateLearningBundleStatus,
} from "../../../store/learningBundlesSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../Styles/Common.css";
const user = JSON.parse(localStorage.getItem("user"));
const userRole = user?.role || null;
const isReadOnly = userRole === "sales";

const LearningBundles = () => {
  const dispatch = useDispatch();
  const { bundles, loading, error } = useSelector((state) => state.learningBundles);

  const [currentPage, setCurrentPage] = useState(1);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isCreatePopup, setCreatePopup] = useState(false);
  const [bundleForm, setBundleForm] = useState({
    LBTitle: "",
    LBIcon: "",
    LBDesc: "",
    LBRoute: "",
    status: "A", // Default status
  });
  const [filterQuery, setFilterQuery] = useState("");
  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
    dispatch(fetchLearningBundles());
  }, [dispatch]);

  const handleOpenCreatePopup = () => {
    setCreatePopup(true);
    setPopupOpen(true);
    setBundleForm({
      LBTitle: "",
      LBIcon: "",
      LBDesc: "",
      LBRoute: "",
      status: "A",
    });
  };

  const handleOpenUpdatePopup = (bundle) => {
    setCreatePopup(false);
    setPopupOpen(true);
    setBundleForm(bundle);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isCreatePopup) {
      dispatch(createLearningBundle(bundleForm))
        .unwrap()
        .then(() => {
          toast.success("Learning bundle created successfully!");
          setPopupOpen(false);
        })
        .catch(() => toast.error("Failed to create learning bundle"));
    } else {
      dispatch(updateLearningBundle(bundleForm))
        .unwrap()
        .then(() => {
          toast.success("Learning bundle updated successfully!");
          setPopupOpen(false);
        })
        .catch(() => toast.error("Failed to update learning bundle"));
    }
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this learning bundle?")) {
      dispatch(deleteLearningBundle(id))
        .unwrap()
        .then(() => toast.success("Learning bundle deleted successfully!"))
        .catch(() => toast.error("Failed to delete learning bundle"));
    }
  };

  const handleStatusToggle = (bundle) => {
    const newStatus = bundle.status === "A" ? "D" : "A";
    dispatch(updateLearningBundleStatus({ id: bundle.id, status: newStatus }))
      .unwrap()
      .then(() => toast.success("Status updated successfully!"))
      .catch(() => toast.error("Failed to update status"));
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const filteredBundles = bundles.filter((bundle) =>
    (bundle?.LBTitle || "").toLowerCase().includes(filterQuery.toLowerCase())
  );

  const paginatedBundles = filteredBundles.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div className="container">
        <div className='header-container'> 
            <h3 >Learning Bundles Management</h3>
            {!isReadOnly && (
              <button className="add-lead-btn" onClick={handleOpenCreatePopup}>
                <i className="fa fa-plus"></i>
              </button>
            )}
        </div>
        <div className="search-section_leads">
            <input
            type="text"
            placeholder="Filter by title"
            value={filterQuery}
            onChange={(e) => setFilterQuery(e.target.value)}
            className="search-input"
            />
        </div>
        {loading ? (
            <p className="loading">Loading...</p>
        ) : error ? (
            <p className="error">{error}</p>
        ) : (
        <>
          <table className="table styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Icon</th>
                <th>Description</th>
                <th>Route</th>
                <th>Status</th>
                <th>Created At</th>
                {!isReadOnly && (
                <th>Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {paginatedBundles.map((bundle, index) => (
                <tr key={bundle.id}>
                  <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                  <td>{bundle.LBTitle}</td>
                  <td>{bundle.LBIcon}</td>
                  <td>{bundle.LBDesc}</td>
                  <td>{bundle.LBRoute}</td>
                  <td>
                    {isReadOnly ? (
                      <span>{bundle.status === "A" ? "Active" : "Deactivated"}</span>
                    ) : (
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={bundle.status === "A"}
                          onChange={() => handleStatusToggle(bundle)}
                        />
                        <span className="slider round"></span>
                      </label>
                    )}
                  </td>
                  <td>{new Date(bundle.created_at).toLocaleString()}</td>
                  {!isReadOnly && (
                  <td>
                      <i
                        className="fa fa-edit action-icon editIcon"
                        onClick={() => handleOpenUpdatePopup(bundle)}
                      ></i>
                      <i
                        className="fa fa-trash action-icon deleteIcon"
                        onClick={() => handleDelete(bundle.id)}
                      ></i>
                  </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination">
            {Array.from({
              length: Math.ceil(filteredBundles.length / ITEMS_PER_PAGE),
            }).map((_, index) => (
              <button
                key={index}
                className={`pagination-btn ${
                  currentPage === index + 1 ? "active" : ""
                }`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </>
      )}
      {isPopupOpen && !isReadOnly &&(
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>{isCreatePopup ? "Add Learning Bundle" : "Update Learning Bundle"}</h3>
            <form onSubmit={handleSubmit} className="form">
            <div className="form-group">
              <label>Learning Bundle Title</label>
              <input
                type="text"
                placeholder="Title"
                value={bundleForm.LBTitle}
                onChange={(e) =>
                  setBundleForm({ ...bundleForm, LBTitle: e.target.value })
                }
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Learning Bundle Icon (fa fa-icon)</label>
              <input
                type="text"
                placeholder="Icon"
                value={bundleForm.LBIcon}
                onChange={(e) =>
                  setBundleForm({ ...bundleForm, LBIcon: e.target.value })
                }
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Learning Bundle Description</label>
              <textarea
                placeholder="Description"
                value={bundleForm.LBDesc}
                onChange={(e) =>
                  setBundleForm({ ...bundleForm, LBDesc: e.target.value })
                }
                className="form-textarea"
              ></textarea>
            </div>            
            <div className="form-group">
              <label>Learning Bundle URL</label>
              <input
                type="text"
                placeholder="Route"
                value={bundleForm.LBRoute}
                onChange={(e) =>
                  setBundleForm({ ...bundleForm, LBRoute: e.target.value })
                }
                required
                className="form-input"
              />
            </div>
              <button type="submit" className="submit-btn">
                {isCreatePopup ? <i className="fa fa-plus-square"></i> : <i className="fa fa-edit"></i>}
              </button>
            <button className="cancel-btn fa fa-close" onClick={() => setPopupOpen(false)}>
            </button>
            </form>
          </div>
        </div>
      )}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
};

export default LearningBundles;
